import React, { useContext, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { Row, Col, Card, Form, Input, Button, Select, Switch, Modal } from 'antd';
import PageTitle from 'shared_components/page_title';
import { SaveOutlined, RollbackOutlined, ExclamationCircleOutlined } from '@ant-design/icons';
import { isEqual, upperCase } from 'lodash';

import BillingAddTable from './billingAddTable';
import DeliveryAddTable from './deliveryAddTable';
import { formatPhoneNumber, formatMobileNumber } from 'utils/helper';
//test
// import {CustomContactNo} from 'components_test/contact_input';
import {
	fetchCustomerCode,
	addCustomers,
	updateCustomers,
	vatLov,
	termsLov,
	addCustomerBill,
	addCustomerDel,
	updateCustBillAdd,
	updateCustDelAdd,
	deleteBillDtl,
	deleteDelDtl,
	getCustomerBillDetails,
	getCustomerDelDetails
} from 'services/customers/customers';

import {
	fetchMessageListAPI,
	fetchAgentsListAPI,
} from 'services/shared/fetchLovList';

import { useState } from 'react';
import Message from 'shared_components/message';

import { CUST_DE_FORM_CHANGED } from 'global_config/constant-global';
import { UserAccessContext } from 'context/userAccess';

const { Option } = Select;

function normalizeEwtRateValue(value) {
	if (value === null || value === undefined || value === '') return '';

	const rawValue = String(value).trim().replace('%', '');
	const numericValue = Number(rawValue);

	if (Number.isNaN(numericValue)) return String(value);
	if (numericValue === 0) return '0';
	if (numericValue === 1 || numericValue === 2) return String(numericValue / 100);
	if (numericValue > 0 && numericValue < 1) return String(numericValue);

	return String(numericValue);
}

export default function AddCust(props) {
	const { userAccess } = useContext(UserAccessContext);
	const updateRight = userAccess['customersSetup'].update;

	const customerDetProps = props.customerDetails === 'undefined' ? '' : props.customerDetails;
	const navigate = useHistory();
	const [form] = Form.useForm();
	const [customerCode, setCustomerCode] = useState();
	const [vatList, setVatlist] = useState([]);
	const [termsList, setTermsList] = useState([]);
	const [agentsList, setAgentsList] = useState([]);
	const [billingData, setBillingData] = useState([]);
	const [deliveryData, setDeliveryData] = useState([]);
	const [isTouchedBill, setTouchBill] = useState(false);
	const [isTouchedDel, setTouchDel] = useState(false);
	const [enableButton, setEnableButton] = useState(true);
	const [customerCodeStr, setCustomerCodeStr] = useState();
	const [messagesList, setMessagesList] = useState([]);
	const [linesForDeleteBill, setlinesForDeleteBill] = useState([]);
	const [linesForDeleteDel, setlinesForDeleteDel] = useState([]);
	const [initFormValue, setInitFormValue] = useState([]);
	const [initBillData, setInitBillData] = useState([]);
	const [initDelData, setInitDelData] = useState([]);

	const [allDisable, setAllDisable] = useState(false);
	//get customer code
	async function getAgentCode() {
		try {
			const generateCode = await fetchCustomerCode();
			setCustomerCode(generateCode.substring(2, 7));
			form.setFieldsValue({ customerCode: generateCode });
		} catch (error) {
			console.log('error', error);
		}
	}

	useEffect(() => {
		async function fetchData() {
			const vatInputList = await vatLov();
			const termsInputList = await termsLov();
			const agentsInputList = await fetchAgentsListAPI();
			const messages = await fetchMessageListAPI();

			setVatlist(vatInputList);
			setTermsList(termsInputList);
			setAgentsList(agentsInputList);
			setMessagesList(messages);
		}
		fetchData();
		if (!props.isEditting) {
			getAgentCode();			
		}
		setInitFormValue(form.getFieldsValue());		
	}, []);

	useEffect(()=> {
		if(props.isEditting){
			if(updateRight === 'TRUE'){
				setAllDisable(false)
			}else{
				setAllDisable(true)
			}
		}
	}, [customerDetProps])

	//handle onchange input of tel_no
	const telNoInput = e => {
		const formattedPhoneNumber = formatPhoneNumber(e.target.value);
		form.setFieldsValue({ tel_no: formattedPhoneNumber });
		compFormVals();
	};

	const mobileNoInput = e => {
		const formattedMobileNumber = formatMobileNumber(e.target.value);
		form.setFieldsValue({ mobile_no: formattedMobileNumber });
		compFormVals();
	};

	const vatOptions = vatList.map((item, index) => {
		return (
			<Option key={index} value={item.vat_input_id}>
				{item.vat_input_name}
			</Option>
		);
	});

	const termOptions = termsList.map((item, index) => {
		return (
			<Option key={index} value={item.term_id}>
				{item.term_name}
			</Option>
		);
	});

	const agentOptions = agentsList.map(item => {
		return (
			<Option key={item.agent_id} value={item.agent_id}>
				{item.agent}
			</Option>
		);
	});

	const handleDataBillAdd = data => {
		// console.log('🚀 ~ file: index.jsx ~ line 92 ~ AddCust ~ data', data);			
		// setBillingData(data);		
		compFormVals();
	};

	const getInitDataBillAddr = billData =>{
		
		const billingAddr = billData.map( x=>{
			return({
				billing_address : upperCase(x.billing_address),
				billing_address_id : x.billing_address_id,
				business_name : upperCase(x.business_name),
				business_style : upperCase(x.business_style),
				contact_person : upperCase(x.contact_person),
				created_by : x.created_by,
				created_date : x.created_date,
				customer_id : x.customer_id,
				last_updated_by : x.last_updated_by,
				last_updated_date : x.last_updated_date,
				mobile_no : x.mobile_no,
				tax_id_no : x.tax_id_no,
				tel_no : x.tel_no,
			});
		});

		setInitBillData(billingAddr);

		setInitFormValue(current =>{
			return {
				...current,
				...{billingAddr}
			}
		});
	}

	const getInitDataDelAddr = delivData =>{		
		const delivAddr = delivData.map(x=>{
			return({
				contact_person : upperCase(x.contact_person),
				location_name : upperCase(x.location_name),								
				delivery_address : upperCase(x.delivery_address),
				delivery_address_id : x.delivery_address_id,
				customer_id : x.customer_id,
				last_updated_by : x.last_updated_by,
				last_updated_date : x.last_updated_date,
				mobile_no : x.mobile_no,
				tel_no : x.tel_no,
				created_by : x.created_by,
				created_date : x.created_date,
			});
		});
		// console.log('delivAddr => ',delivAddr);
		setInitDelData(delivAddr);

		setInitFormValue(current =>{
			return {
				...current,
				...{delivAddr}
			}
		});
	}

	const handleDataDeliveryAdd = data => {
		// console.log("🚀 ~ file: index.jsx ~ line 103 ~ handleDataDeliveryAdd ~ data", data)
		setDeliveryData(data);
		// compFormVals();
	};

	const handleDisable = data => {
		setEnableButton(data);
	};

	const setEnableBill = data => {
		// console.log(data);
		setTouchBill(data);
	};

	const setEnableDel = data => {
		// console.log(data);
		setTouchDel(data);
	};

	//fetches and prepares to be deleted lines from billing table
	function handleForDeleteBill(data){
		setlinesForDeleteBill(data);
	}

	//fetches and prepares to be deleted lines from delivery table
	function handleForDeleteDel(data){
		setlinesForDeleteDel(data);
	}

	function handleSubmit(formValues) {
		const m0003 = messagesList.filter(items => items.message_code === 'M0003');		
		// call modal
		// console.log('console for delivery',deliveryData);
		// console.log('console for billing',billingData);

			const isRequiredLineValueInvalid = value => {
				if (value === undefined || value === null) return true;
				const normalized = String(value).trim();
				return normalized === '' || normalized === '-';
			};

			const invalidDeliveryRows = deliveryData.filter(item =>
				isRequiredLineValueInvalid(item.location_name) ||
				isRequiredLineValueInvalid(item.delivery_address),
			);

			const invalidBillingRows = billingData.filter(item =>
				isRequiredLineValueInvalid(item.business_name) ||
				isRequiredLineValueInvalid(item.tax_id_no) ||
				item.tax_id_no === '000-000-000-00000' ||
				isRequiredLineValueInvalid(item.billing_address) ||
				isRequiredLineValueInvalid(item.business_style),
			);

			//if line details are incomplete (blank, "-" or placeholder value)
			if (invalidDeliveryRows.length > 0 || invalidBillingRows.length > 0) {
				const m0025 = messagesList.filter(items => items.message_code === 'M0025');
				Message.error({ message: m0025[0].message_display });
			}else {

				Modal.confirm({
					title: m0003[0].message_title,
					icon: <ExclamationCircleOutlined />,
					content: m0003[0].message_display,
					okText: 'YES',
					cancelText: 'NO',
					onOk: () => {
						onOkSubmit(formValues);
					},
			});
		}
	}

	async function onOkSubmit(formValues) {
		const payload = {
			customer_id: Number(formValues.customerCode.substring(2, 7)),
			customer_code: formValues.customerCode,
			customer_name: formValues.cust_name,
			tel_no: formValues.tel_no,
			mobile_no: formValues.mobile_no,
			office_address: formValues.address,
			vat_input_id: formValues.vat_input,
			agent_id: Number(formValues.agent),
			term_id: formValues.terms,
			ewt_rate: formValues.ewt_rate,
			created_by: 0,
			status: formValues.status,
		};

		const mappedBillingData = billingData.map(value => {
			return {
				// key: value.key,
				billing_address_id: value.billing_address_id,
				forced_customer_id: Number(formValues.customerCode.substring(2, 7)),
				customer_id: value.customer_id,
				business_name: value.business_name,
				tax_id_no: value.tax_id_no,
				billing_address: value.billing_address,
				tel_no: value.tel_no,
				mobile_no: value.mobile_no,
				business_style: value.business_style,
				contact_person: value.contact_person,
				created_by: 0,
			};
		});

		const mappedDeliveryData = deliveryData.map(value => {
			return {
				// key: value.key,
				customer_id: value.customer_id,
				forced_customer_id: Number(formValues.customerCode.substring(2, 7)),
				location_name: value.location_name,
				delivery_address: value.delivery_address,
				contact_person: value.contact_person,
				delivery_address_id: value.delivery_address_id,
				mobile_no: value.mobile_no,
				tel_no: value.tel_no,
				created_by: 0,
			};
		});


		if (!props.isEditting) {
			try {
				if (isTouchedDel && mappedDeliveryData.length > 0) {
					const resultDelivery = await addCustomerDel(mappedDeliveryData);
					// console.log('add delivery details', resultDelivery);
				}

				if (isTouchedBill && mappedBillingData.length > 0) {
					const resultBilling = await addCustomerBill(mappedBillingData);
					// console.log('add billing details', resultBilling);
				}

				const result = await addCustomers(payload);

				if (result.status === 200) {
					const M0017 = messagesList.filter(items => items.message_code === 'M0017'); 
					Message.success({ message: M0017[0].message_display });
					navigate.push('/customer/search');
				}
			} catch (error) {
				console.log('error', error);
				Message.error();
			}
		} else {
			try {

				if(linesForDeleteBill.length > 0){
					const res = await deleteBillDtl(linesForDeleteBill);
					// console.log("🚀 ~ file: index.jsx ~ line 226 ~ onOkSubmit ~ res", res)
				}

				if(linesForDeleteDel.length > 0){
					// console.log("🚀 ~ file: index.jsx ~ line 238 ~ onOkSubmit ~ linesForDeleteDel.length", linesForDeleteDel.length)
					const res = await deleteDelDtl(linesForDeleteDel);
					// console.log("🚀 ~ file: index.jsx ~ line 237 ~ onOkSubmit ~ res", res)
				}
				

				if (isTouchedDel && mappedDeliveryData.length > 0) {
					const updateDelAdd = await updateCustDelAdd(mappedDeliveryData);
					// console.log('update delivery details', updateDelAdd);

					//add billing address for new line of details
					const filteredList = [mappedDeliveryData];

					const filterDataUndefined = mappedDeliveryData.filter(listData => {
						return filteredList.find(inv => {
							return listData.customer_id === undefined;
						});
					});

					const dataForAddDelAdd = filterDataUndefined.map(value => {
						return {
							...value,
							customer_id: value.forced_customer_id,
						};
					});

					//add delivery address
					if (dataForAddDelAdd.length > 0) {
						const resultDelivery = await addCustomerDel(dataForAddDelAdd);
						// console.log(resultDelivery)
					}
				}

				if (isTouchedBill && mappedBillingData.length > 0) {
					// update billing details
					const updateBillAdd = await updateCustBillAdd(mappedBillingData);
					// console.log('update billing details', updateBillAdd);

					// add billing address for new line of details
					const filteredList = [mappedBillingData];
					const filterDataUndefined = mappedBillingData.filter(listData => {
						return filteredList.find(inv => {
							return listData.customer_id === undefined;
						});
					});

					const dataForAddBillAdd = filterDataUndefined.map(value => {
						return {
							...value,
							customer_id: value.forced_customer_id,
						};
					});

					// add billing address
					if (dataForAddBillAdd.length > 0) {
						const resultBilling = await addCustomerBill(dataForAddBillAdd);
						// console.log('add billing details', resultBilling);
					}
				}

				const result = await updateCustomers(payload);

				if (result.status === 200) {
					const M0019 = messagesList.filter(items => items.message_code === 'M0019'); 
					Message.success({ message: M0019[0].message_display });
					navigate.push('/customer/search');
				}
			} catch (error) {
				console.log('error', error);
				Message.error();
			}
		}
	}

	const handleBack = () => {

		const m0008 = messagesList.filter(items => items.message_code === 'M0008');
		
        const checkBackVal = form.getFieldsValue(null, meta => meta.touched);
        const backArr = Object.values(checkBackVal);
        // console.log('back form values', backArr)

		if (!props.isEditting){//ADD LOGIC
			if (backArr.length > 1 || isTouchedDel || isTouchedBill){
				const m0008Title = m0008[0].message_title === undefined ? '' : m0008[0].message_title;
				const m0008Message = m0008[0].message_display === undefined ? 'Changes will be cancelled' : m0008[0].message_display;
					Modal.confirm({
						title: m0008Title,
						icon: <ExclamationCircleOutlined />,
						content: m0008Message,
						okText: 'YES',
						cancelText: 'NO',
						onOk: ()=>{ navigate.push('/customer/search') }
					});
			}else{
				navigate.push('/customer/search');
			}
		}else{//UPDATE LOGIC
			// console.log('back form values', backArr);
			if (backArr.length > 0 || isTouchedDel || isTouchedBill){
				const m0008Title = m0008[0].message_title === undefined ? '' : m0008[0].message_title;
				const m0008Message = m0008[0].message_display === undefined ? 'Changes will be cancelled' : m0008[0].message_display;
					Modal.confirm({
						title: m0008Title,
						icon: <ExclamationCircleOutlined />,
						content: m0008Message,
						okText: 'YES',
						cancelText: 'NO',
						onOk: ()=>{ navigate.push('/customer/search') }
					});
			}else{
				navigate.push('/customer/search');
			}
		}
		
	};

	function handleNewBill(data){
		// console.log('handleNewBill =>',data);
		setBillingData(data);
		compFormVals({dataType: 'billing', contents: data})
	}

	function handleNewDel(data){
		// console.log('handleNewDel =>', data);
		setDeliveryData(data);
		compFormVals({dataType: 'delivery', contents: data})
	}

	function compFormVals(data){
		const {cust_name, customerCode, address, mobile_no, status, tel_no, terms, vat_input, agent} = form.getFieldsValue();
		let billingAddr = billingData;
		let delivAddr = deliveryData;

		if(data !== undefined){
			// console.log('data =>', data.contents);
			const { contents, dataType } = data;

			if(dataType === 'billing'){
				// billingAddr = data.contents;
				billingAddr = contents.map(x=>{
					return({
						billing_address : upperCase(x.billing_address),
						billing_address_id : x.billing_address_id,
						business_name : upperCase(x.business_name),
						business_style : upperCase(x.business_style),
						contact_person : upperCase(x.contact_person),
						created_by : x.created_by,
						created_date : x.created_date,
						customer_id : x.customer_id,
						last_updated_by : x.last_updated_by,
						last_updated_date : x.last_updated_date,
						mobile_no : x.mobile_no,
						tax_id_no : x.tax_id_no,
						tel_no : x.tel_no,
					});
				});
			}else if(dataType === 'delivery'){
				// delivAddr = data.contents;

				delivAddr = contents.map(x=>{
					return({
						contact_person : upperCase(x.contact_person),
						location_name : upperCase(x.location_name),								
						delivery_address : upperCase(x.delivery_address),
						delivery_address_id : x.delivery_address_id,
						customer_id : x.customer_id,
						last_updated_by : x.last_updated_by,
						last_updated_date : x.last_updated_date,
						mobile_no : x.mobile_no,
						tel_no : x.tel_no,
						created_by : x.created_by,
						created_date : x.created_date,
					});
				});

			}


	
			const currVal = {
				cust_name, customerCode, address, mobile_no, status, tel_no, terms, vat_input, agent, ...{billingAddr}, ...{delivAddr}
			};
	
			// console.log('initValues =>', initFormValue);
			// console.log('currVal =>', currVal);
	
			const initChangeModal = isEqual(initFormValue, currVal) ? 'false' : 'true';

			// console.log('initChangeModal =>', initChangeModal);

			sessionStorage.setItem(CUST_DE_FORM_CHANGED, initChangeModal); //setItem requires string input
	
			// console.log('eq =>', eq);
		}
		// const dtype = data.dataType === undefined ? '' : data.dataType;
				
	}

	return (
		<div id="add_customers">
			<Card>
				<PageTitle pageTitle="CUSTOMER DETAILS" />
				<Form
					layout="vertical"
					onFinish={handleSubmit}
					form={form}
					className="form-details-customers"
				>
					{/* customer details */}
					<Row gutter={[8, 1]} justify="end">
						<Col>
							<Form.Item
								name="status"
								initialValue={props.isEditting ? customerDetProps.is_active : true}
							>
								<Switch
									checkedChildren="Active"
									unCheckedChildren="Inactive"
									defaultChecked={props.isEditting ? customerDetProps.is_active : true}
									disabled={allDisable}
								/>
							</Form.Item>
						</Col>
					</Row>
					<Row gutter={[8, 1]} align="top">
						<Col span={24}>
							<Row gutter={[8, 1]}>
								<Col span={4}>
									<Form.Item
										label="CUSTOMER CODE"
										name="customerCode"
										initialValue={props.isEditting ? customerDetProps.customer_code : customerCode}
									>
										<Input placeholder="CUSTOMER CODE" value={customerCode} disabled />
									</Form.Item>
								</Col>
								<Col span={12}>
									<Form.Item
										label="CUSTOMER NAME"
										rules={[{ required: true, message: 'Required Field' }]}
										name="cust_name"
										initialValue={props.isEditting ? customerDetProps.customer_name : ''}
									>
										<Input maxLength={100} placeholder="CUSTOMER NAME" onChange={compFormVals} onBlur={compFormVals}
											disabled={allDisable}
										/>
									</Form.Item>
								</Col>
								<Col span={4}>
									<Form.Item
										label="TEL. NO."
										name="tel_no"
										initialValue={props.isEditting ? customerDetProps.tel_no : ''}
									>
										{/* <CustomContactNo placeholder="TEL. NO." /> */}
										<Input placeholder="(632)XXXX-YYYY" onChange={telNoInput} disabled={allDisable} />
									</Form.Item>
								</Col>
								<Col span={4}>
									<Form.Item
										label="MOBILE NO."
										name="mobile_no"
										initialValue={props.isEditting ? customerDetProps.mobile_no : ''}
									>
										{/* <CustomContactNo placeholder="TEL. NO." /> */}
										<Input placeholder="(639)XX-XXX-YYYY" onChange={mobileNoInput} disabled={allDisable} />
									</Form.Item>
								</Col>
							</Row>
							<Row gutter={[8, 1]}>
								<Col span={8}>
									<Form.Item
										label="ADDRESS"
										rules={[{ required: true, message: 'Required Field' }]}
										name="address"
										initialValue={props.isEditting ? customerDetProps.office_address : ''}
									>
										<Input
											// className='inv-input-uppercase'
											placeholder="ADDRESS"
											maxLength={200}
											onChange={compFormVals}
											disabled={allDisable}
										/>
									</Form.Item>
								</Col>
								<Col span={4}>
									<Form.Item
										label="AGENT"
										rules={[{ required: true, message: 'Required Field' }]}
										name="agent"
										initialValue={props.isEditting ? customerDetProps.agent_id : undefined}
									>
										<Select placeholder="AGENT" onChange={compFormVals} disabled={allDisable} >
											{agentOptions}
										</Select>
									</Form.Item>
								</Col>
								<Col span={4}>
									<Form.Item
										label="VAT INPUT"
										rules={[{ required: true, message: 'Required Field' }]}
										name="vat_input"
										initialValue={props.isEditting ? customerDetProps.vat_input_id : ''}
									>
										<Select placeholder="VAT INPUT" onChange={compFormVals}
											disabled={allDisable}
										>{vatOptions}</Select>
									</Form.Item>
								</Col>
								<Col span={4}>
									<Form.Item
										label="EWT RATE"
										rules={[{ required: true, message: 'Required Field' }]}
										name="ewt_rate"
										initialValue={
											props.isEditting && customerDetProps.ewt_rate !== null && customerDetProps.ewt_rate !== undefined
												? normalizeEwtRateValue(customerDetProps.ewt_rate)
												: ''
										}
									>
										<Select placeholder="EWT RATE" onChange={compFormVals} disabled={allDisable} >
											<Option value="0">0%</Option>
											<Option value="0.01">1%</Option>
											<Option value="0.02">2%</Option>
										</Select>
									</Form.Item>
								</Col>
								<Col span={4}>
									<Form.Item
										label="TERMS"
										rules={[{ required: true, message: 'Required Field' }]}
										name="terms"
										initialValue={props.isEditting ? customerDetProps.term_id : ''}
									>
										<Select placeholder="TERMS" onChange={compFormVals} disabled={allDisable} >{termOptions}</Select>
									</Form.Item>
								</Col>
							</Row>
						</Col>
					</Row>
					{/* billing address */}
					<Row gutter={[8, 1]} align="top">
						<Col span={24}>
							<BillingAddTable
								onSubmit={handleDataBillAdd}
								dataBillAdd={customerDetProps}
								isEditting={props.isEditting}
								forDeleteBilling={handleForDeleteBill}
								touchedBillAdd={setEnableBill}
								getInitData={getInitDataBillAddr}
								sendNewBill={handleNewBill}
								disabled={allDisable}
							/>
						</Col>
					</Row>
					{/* delivery address */}
					<Row gutter={[8, 1]} align="top">
						<Col span={24}>
							<DeliveryAddTable
								onSubmit={handleDataDeliveryAdd}
								dataDelAdd={customerDetProps}
								isEditting={props.isEditting}
								touchedBillAdd={setEnableDel}
								forDeleteDelivery={handleForDeleteDel}
								getInitData={getInitDataDelAddr}
								sendNewDel={handleNewDel}
								disabled={allDisable}
							/>
						</Col>
					</Row>					 
					<Row gutter={[8, 1]} align="top"></Row>
					{/* buttons */}
					<Row gutter={[8, 1]} justify="end">
						<Col style={{ marginTop: 50 }}>
							<Form.Item>
								<Button
									className="inv-button-right"
									type="primary"
									onClick={handleBack}
									icon={<RollbackOutlined />}
								>
									BACK
								</Button>
								<Button
									className="inv-button"
									type="primary"
									icon={<SaveOutlined />}
									htmlType="submit"
									disabled={allDisable}
								>
									SAVE
								</Button>
							</Form.Item>
						</Col>
					</Row>
				</Form>
			</Card>
		</div>
	);
}
